import axios from 'axios'

//Default values
const state = {}

const mutations = {}

const actions = {
    SAVE_USER: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'users', payload)
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    GET_USER: async (context, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'users/' + payload)
            .then((res) => {
                return res.data
            })
    },
    GET_USERS: async ({rootState, commit}, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'users', {
            params: {
                page: rootState.table.table.serverParams.page,
                perPage: rootState.table.table.serverParams.perPage
            }
        })
            .then((res) => {
                commit('FETCH_ITEMS', res.data)
            })
    },
    UPDATE_USER: async (context, payload) => {
        return axios.put(process.env.VUE_APP_API_URL + 'users/' + payload.id, payload)
            .then((res) => {
                return res.data
            })
    }
}

const getters = {}

export default {
    state,
    mutations,
    actions,
    getters
}
